import {
  RISK_RULE_TYPE_NUMBER_OF_TRANSACTIONS,
  RISK_RULE_TYPE_TRANSACTION_AMOUNT,
  RISK_RULE_TYPE_VOLUME_OF_TRANSACTIONS,
} from "../../constants";
import { transactionAmountParser } from "./transactionAmount";
import { numberOfTransactionsParser } from "./transactionNumber";
import { volumeOfTransactionsParser } from "./transactionVolume";

import type { RiskRuleAlias } from "../../models/RiskRule";

export const riskRuleTranslator = (rule: RiskRuleAlias, bankName?: string) => {
  switch (rule.type) {
    case RISK_RULE_TYPE_NUMBER_OF_TRANSACTIONS:
      return numberOfTransactionsParser(rule, bankName);
    case RISK_RULE_TYPE_TRANSACTION_AMOUNT:
      return transactionAmountParser(rule, bankName);
    case RISK_RULE_TYPE_VOLUME_OF_TRANSACTIONS:
      return volumeOfTransactionsParser(rule, bankName);
    default:
      return;
  }
};
